import styled from 'styled-components';

export const TableWrapper = styled.div`
  text-align: left;
  thead tr th {
    text-align: left;
  }
`;
